"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTotalSpend = void 0;
var lodash_1 = require("lodash");
var SPEND_FIELDS = ['calculatedAnnualSpend', 'spend13to24Months', 'spend25to36Months', 'spendBeforeMonth36'];
var calculateTotalSpend = function (serviceStat) { return (0, lodash_1.sumBy)(SPEND_FIELDS, function (f) { var _a; return (_a = serviceStat[f]) !== null && _a !== void 0 ? _a : 0; }); };
exports.calculateTotalSpend = calculateTotalSpend;
